import { Component, Input, OnInit } from '@angular/core';
import { IconService } from 'src/app/shared/services/icon.service';

@Component({
  selector: 'app-student-grades-summary-block-list',
  templateUrl: './student-grades-summary-block-list.component.html',
  styleUrls: ['./student-grades-summary-block-list.component.scss'],
})
export class StudentGradesSummaryBlockListComponent implements OnInit {
  blockData: any;
  isServerError: boolean = false;
  @Input() set data(value: any) {
    if (value) {
      this.iconService.addIconToRegistry({
        key: value.icon ? value.icon : '',
        path: value.icon ? value.icon : '',
      });
      this.blockData = value;
    }
  }

  constructor(private iconService: IconService) {}

  ngOnInit(): void { 
    this.isServerError = this.blockData.isTimeoutErrorAppeared;
  }
}
